import { gameAction } from "_actions";
import { GameService } from "_services";
import React, { useEffect, useState } from "react";
import { Translation } from "react-i18next";
import { connect } from "react-redux";
import ScrollableListView from "../ScrollableListView";
import { Helmet } from "react-helmet";
import { useParams } from "react-router-dom";
import { ServiceURLs } from "_services";
import i18n from "i18n";
import { isBrowser, isMobile } from "react-device-detect";
import { detroidVirtualGames } from "BaseServiceURLs";
import { detroidGames } from "BaseServiceURLs";

const Detroit = (props) => {
  const { user, loggedIn, sports, games, UpdateGames, demo } = props;
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);

  function GetParams() {
    let params = useParams();
    return params;
  }
  let params = GetParams();

  useEffect(() => {
    if (
      !loading &&
      params &&
      params.ProviderId &&
      params.GameId &&
      props.games
    ) {
      const g = props.games;
      if (g && g.hasOwnProperty(params.ProviderId)) {
        const _data = g[params.ProviderId].find(
          (x) => x.gamecode == params.GameId
        );
        if (!demo) {
          if (_data) {
            getGameDetail(_data.gamecode, _data);
          } else {
            alert("Oyun bulunamadı !");
          }
        } else {
          if (_data) {
            getGameDemoDetail(_data.gamecode, _data);
          } else {
            alert("Oyun bulunamadı !");
          }
        }
      }
    }
  }, []);

  useEffect(() => {
    if (
      !loading &&
      params &&
      params.ProviderId &&
      params.GameId &&
      props.games
    ) {
      const g = props.games;
      if (g && g.hasOwnProperty(params.ProviderId)) {
        const _data = g[params.ProviderId].find(
          (x) => x.gamecode == params.GameId
        );
        if (!demo) {
          if (_data) {
            getGameDetail(_data.gamecode, _data);
          } else {
            alert("Oyun bulunamadı !");
          }
        } else {
          if (_data) {
            getGameDemoDetail(_data.gamecode, _data);
          } else {
            alert("Oyun bulunamadı !");
          }
        }
      }
    }
  }, [games]);

  let startget = false;

  const getGameDetail = (id_game, gdata) => {
    if (!startget) {
      startget = true;
      setLoading(true);
      let PlayCategory = "SLOT";

      const pvData = detroidVirtualGames.find(
        (x) => x.provider == params.ProviderId
      );
      const pgData = detroidGames.find((x) => x.provider == params.ProviderId);
      if (pvData && pvData.data.find((x) => x == id_game)) {
        PlayCategory = "VIRTUAL";
      } else if (pgData && pgData.data.find((x) => x == id_game)) {
        PlayCategory = "GAMES";
      } else {
        PlayCategory = "SLOT";
      }

      debugger;

      GameService.GET_DETROIT_SLOT_GAME(
        id_game,
        props.currentLang,
        isMobile ? "MOBILE" : "DESKTOP",
        undefined,
        params.ProviderId,
        PlayCategory
      )
        .then((res) => {
          setLoading(false);
          debugger;
          setData(res.url);
          //  openInNewTab(res.url);
          startget = false;
        })
        .catch((err) => {
          debugger;

          setLoading(false);
        });
    }
  };

  const getGameDemoDetail = (id_game, data) => {
    if (!startget) {
      startget = true;
      setLoading(true);
      GameService.GET_DETROIT_SLOT_GAME(id_game, props.currentLang)
        .then((res) => {
          setLoading(false);
          debugger;
          setData(res.url);
          // openInNewTab(res.url);
        })
        .catch((err) => {
          debugger;

          setLoading(false);
        });
    }
  };
  /*
  const adjustHeight = () => {
    const windowHeight = window.innerHeight;
     try {
      document.querySelector(".gameiframe").style.height = `${windowHeight}px`;
    } catch (error) {
      
    }
  };

  useEffect(() => {
    window.addEventListener("DOMContentLoaded", adjustHeight);
    window.addEventListener("resize", adjustHeight);
  }, []);
*/

  function openInNewTab(url) {
    var newWindow = window.open(url);
    newWindow.focus();
  }

  return (
    <Translation>
      {(t) => (
        <>
          <Helmet>
            <title>{t("TITLE_CASINO")}</title>
            <style type="text/css">
              {`
      .base-nav {
        display: none !important;
        
      }
      .base-nav1 {
        display: none !important;
        
      }
      body, html , #root{
        height: 100%;
        margin: 0;
        overflow: hidden;
    }
    .appdiv{
      height: 100% !important;
    }
    iframe {
        width: 100%;
        height: 100%;
        border: none;
    }
      
      
    `}
            </style>
          </Helmet>
          {data && <iframe src={data} allowfullscreen></iframe>}
        </>
      )}
    </Translation>
  );
};
// height: "calc(100vh - 72px)",
const mapStateToProps = (state, props) => {
  const { authentication, game } = state;
  const { user, loggedIn, currentLang } = authentication;
  const { sports, games } = game;
  return {
    user,
    loggedIn,
    sports,
    games,
    currentLang,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    UpdateGames: (data) => dispatch(gameAction.UpdateGamesData(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Detroit);
